<!--
  WorkflowGraphView — a read-only render of the same workflow graph the Advanced Workflows tab shows.
  Reuses the VueFlow setup + WorkflowNode from the workflow editor; nodes/edges are built by the shared
  src/utils/workflowGraph.ts. View-only: no dragging, selecting, or node clicks.
-->
<template>
  <div class="workflow-graph-view">
    <VueFlow
      :nodes="nodes"
      :edges="edges"
      :nodes-draggable="false"
      :nodes-connectable="false"
      :elements-selectable="false"
      :pan-on-drag="true"
      fit-view-on-init
      class="vue-flow-container"
    >
      <Background pattern-color="rgba(var(--v-theme-primary), 0.12)" :gap="24" />
      <Controls position="bottom-right" :show-interactive="false" />
      <template #node-mainAgent="props"><WorkflowNode v-bind="props" /></template>
      <template #node-helperAgent="props"><WorkflowNode v-bind="props" /></template>
      <template #node-tool="props"><WorkflowNode v-bind="props" /></template>
      <template #node-embeddingCollection="props"><WorkflowNode v-bind="props" /></template>
    </VueFlow>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { VueFlow, type Node, type Edge } from '@vue-flow/core'
import { Background } from '@vue-flow/background'
import { Controls } from '@vue-flow/controls'
import WorkflowNode from '@/components/workflows/WorkflowNode.vue'

@Options({
  components: { VueFlow, Background, Controls, WorkflowNode },
  props: {
    nodes: { type: Array, default: () => [] },
    edges: { type: Array, default: () => [] }
  }
})
export default class WorkflowGraphView extends Vue {
  nodes!: Node[]
  edges!: Edge[]
}
</script>

<style scoped lang="scss">
.workflow-graph-view {
  height: 360px;
  width: 100%;
  border: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
  border-radius: 8px;
  overflow: hidden;
}
.vue-flow-container {
  height: 100%;
  width: 100%;
}
</style>
